import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle, Clock } from "lucide-react";
import api, { formatPrice } from "@/lib/api";

const LABELS = {
  paid: { icon: CheckCircle2, color: "#22C55E", title: "Betaling geslaagd", text: "Je betaling is ontvangen. De verkoper is op de hoogte gebracht." },
  pending: { icon: Clock, color: "#FFB27A", title: "Betaling in behandeling", text: "We wachten op bevestiging van je bank. Dit kan even duren." },
  open: { icon: Clock, color: "#FFB27A", title: "Betaling in behandeling", text: "We wachten op bevestiging van je bank." },
  failed: { icon: XCircle, color: "#EF4444", title: "Betaling mislukt", text: "De betaling is niet gelukt. Probeer het opnieuw." },
  expired: { icon: XCircle, color: "#EF4444", title: "Betaling verlopen", text: "De betaallink is verlopen." },
  canceled: { icon: XCircle, color: "#EF4444", title: "Betaling geannuleerd", text: "De betaling is geannuleerd." },
};

export default function PaymentStatus() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orderId) { setLoading(false); return; }
    let tries = 0;
    const load = async () => {
      try {
        const { data } = await api.get(`/orders/${orderId}`);
        setOrder(data); setLoading(false);
        if (["paid", "failed", "expired", "canceled"].includes(data.status)) clearInterval(t);
      } catch { setLoading(false); }
      if (++tries > 20) clearInterval(t);
    };
    const t = setInterval(load, 2500);
    load();
    return () => clearInterval(t);
  }, [orderId]);

  const info = order ? (LABELS[order.status] || LABELS.pending) : null;
  const isFee = order?.type === "listing_fee";

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md items-center px-4 py-10">
      <div className="w-full rounded-2xl border border-[#333] bg-[#1c1c1c] p-8 text-center" data-testid="payment-status">
        {loading || !order ? <Loader2 className="mx-auto h-12 w-12 animate-spin text-[#FF6A00]" /> : (
          <>
            <info.icon className="mx-auto mb-3 h-14 w-14" style={{ color: info.color }} />
            <h1 className="font-display text-2xl text-[#F5F5F5]">{isFee && order.status === "paid" ? "Advertentie staat online" : info.title}</h1>
            <p className="mt-2 text-[#A0A0A0]">{isFee && order.status === "paid" ? "Je betaling is ontvangen. Je advertentie is nu 4 weken online." : info.text}</p>
            <div className="mt-4 rounded-lg border border-[#333] bg-[#111] p-3 text-left text-sm">
              <p className="text-[#A0A0A0]">{isFee ? "Advertentie" : "Artikel"}</p><p className="font-semibold text-[#F5F5F5]">{order.listing_title}</p>
              <p className="mt-2 text-[#A0A0A0]">Bedrag</p><p className="font-display text-xl text-[#FF6A00]">{formatPrice(order.amount)}</p>
              <p className="mt-2 text-xs text-[#777]">Order: {order.id}</p>
            </div>
            {isFee && order.status === "paid" && order.listing_id ? (
              <Link to={`/advertentie/${order.listing_id}`} data-testid="view-listing-btn" className="mt-6 inline-block rounded-full bg-[#FF6A00] px-6 py-3 font-bold text-[#111]">Bekijk je advertentie</Link>
            ) : isFee && ["failed", "expired", "canceled"].includes(order.status) ? (
              <Link to="/profiel" data-testid="retry-fee-btn" className="mt-6 inline-block rounded-full bg-[#FF6A00] px-6 py-3 font-bold text-[#111]">Naar mijn advertenties</Link>
            ) : (
              <Link to="/" className="mt-6 inline-block rounded-full bg-[#FF6A00] px-6 py-3 font-bold text-[#111]">Terug naar home</Link>
            )}
          </>
        )}
      </div>
    </div>
  );
}
